module.exports = __webpack_public_path__ + "media/icons/icon-question-mark-2c67cdc8.svg";